import React from "react";
import classNames from "classnames";
import { Tooltip } from "antd";
import { EventRowSeverity } from "../../../../../../../core/enums/report";
import "./eventRow.scss";
import ICON_CRITICAL from "../../../../../../../assets/img/alertSvgRed.svg";
import ICON_MODERATE from "../../../../../../../assets/img/alertSvgYellow.svg";
import ICON_LOW from "../../../../../../../assets/img/alertSvgGreen.svg";
import ICON_DARK_GREEN from "../../../../../../../assets/img/alertSvgDarkGreen.svg";
import ICON_GREY from "../../../../../../../assets/img/alertSvgGrey.svg";
function assetsForSeverity(severity) {
    if (severity === "UNKNOWN") {
        return { icon: ICON_GREY };
    }
    const band = (severity !== null && severity !== void 0 ? severity : "D").trim().toUpperCase();
    if (band === "A")
        return { icon: ICON_DARK_GREEN };
    if (band === "B")
        return { icon: ICON_LOW };
    if (band === "C")
        return { icon: ICON_MODERATE };
    if (band === "D")
        return { icon: ICON_CRITICAL };
    const lower = (severity !== null && severity !== void 0 ? severity : "").trim().toLowerCase();
    if (lower === "moderate" || severity === EventRowSeverity.WARNING) {
        return { icon: ICON_MODERATE };
    }
    if (lower === "low" || severity === EventRowSeverity.LOW) {
        return { icon: ICON_LOW };
    }
    return { icon: ICON_CRITICAL };
}
function eventRowSeverityModifierClass(severity) {
    if (severity === "UNKNOWN") {
        return "event-row--no-band";
    }
    const band = (severity !== null && severity !== void 0 ? severity : "").trim().toUpperCase();
    if (band === "A")
        return "event-row--band-a";
    if (band === "B")
        return "event-row--low";
    if (band === "C")
        return "event-row--moderate";
    if (band === "D")
        return "event-row--D";
    const lower = (severity !== null && severity !== void 0 ? severity : "").trim().toLowerCase();
    if (lower === "moderate" || severity === EventRowSeverity.WARNING) {
        return "event-row--moderate";
    }
    if (lower === "low" || severity === EventRowSeverity.LOW) {
        return "event-row--low";
    }
    return undefined;
}
const EventRow = ({ title, subtitle, time, status, className, severity, iconSrc, statusVariant = "text", daysOpenCount = "6", }) => {
    const assets = assetsForSeverity(severity);
    const icon = iconSrc !== null && iconSrc !== void 0 ? iconSrc : assets.icon;
    return (React.createElement("div", { className: classNames("event-row", eventRowSeverityModifierClass(severity), className), role: "group", "data-node-id": "1:4772" },
        React.createElement("div", { className: "event-row__layer event-row__layer--4773", "data-node-id": "1:4773", "aria-hidden": true }),
        React.createElement("div", { className: "event-row__layer event-row__layer--4774", "data-node-id": "1:4774", "aria-hidden": true }),
        React.createElement("div", { className: "event-row__left", "data-node-id": "1:4776" },
            React.createElement("div", { className: "event-row__icon-col", "data-node-id": "1:4777", "data-name": "Container" },
                React.createElement("div", { className: "event-row__icon-box", "data-node-id": "1:4778", "data-name": "SVG" },
                    React.createElement("img", { alt: "", className: "event-row__icon-img", src: icon }))),
            React.createElement("div", { className: "event-row__copy", "data-node-id": "1:4780" },
                React.createElement("div", { className: "event-row__titles", "data-node-id": "1:4781" },
                    React.createElement("div", { className: "event-row__title-wrap", "data-node-id": "1:4782" },
                        React.createElement("p", { className: "event-row__title", title: title }, title)),
                    React.createElement("div", { className: "event-row__subtitle-wrap", "data-node-id": "1:4783" },
                        React.createElement(Tooltip, { placement: "top", autoAdjustOverflow: true, title: subtitle ? (React.createElement("span", { className: "event-row__subtitle-tooltip-content", dangerouslySetInnerHTML: { __html: subtitle } })) : null, overlayClassName: "event-row__subtitle-tooltip", overlayInnerStyle: {
                                maxWidth: "min(520px, calc(100vw - 48px))",
                                whiteSpace: "normal",
                                wordBreak: "break-word",
                            } },
                            React.createElement("p", { className: "event-row__subtitle", dangerouslySetInnerHTML: { __html: subtitle !== null && subtitle !== void 0 ? subtitle : "" } })))),
                React.createElement("div", { className: "event-row__time-outer", "data-node-id": "1:4784", "data-name": "Container" },
                    React.createElement("div", { className: "event-row__time-wrap", "data-node-id": "1:4785" },
                        React.createElement("p", { className: "event-row__time" }, time))))),
        React.createElement("div", { className: "event-row__status", "data-node-id": "1:4786" },
            React.createElement("div", { className: "event-row__status-inner", "data-node-id": "1:4787" }, statusVariant === "daysOpen" ? (React.createElement("p", { className: "event-row__status-text event-row__status-text--days-open" },
                React.createElement("span", { className: "event-row__days-open-num" }, daysOpenCount),
                React.createElement("span", { className: "event-row__days-open-suffix" }, " DAYS OPEN"))) : (React.createElement("p", { className: "event-row__status-text" }, status))))));
};
export default EventRow;
